export default __webpack_public_path__ + "images/4T.c52e099.png";